import {ApiBaseService} from "@portal/api/api-base-service";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {UserAddRequest} from "@portal/api/requests/users/user-add-request";
import {Observable} from "rxjs";
import {Guid} from "guid-typescript";
import {ListResponse} from "@portal/api/responses/api-response";
import {SearchRequest} from "@portal/api/requests/search-request";
import {UserListResponse} from "@portal/api/responses/users/user-list-response";
import { UserUpdateRequest } from "../requests/users/user-update-request";
import {BrandAddRequest} from "@portal/api/requests/brands/brand-add-request";
import {BrandUpdateRequest} from "@portal/api/requests/brands/brand-update-request";
import {BrandListResponse} from "@portal/api/responses/brands/brand-list-response";

@Injectable({
    providedIn: 'root'
})
export class BrandsService extends ApiBaseService {
    controller = 'brands';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    add(obj: BrandAddRequest): Observable<Guid> {
        return this.post<Guid, BrandAddRequest>(obj, this.controller);
    }

    update(obj: BrandUpdateRequest): Observable<Guid> {
        return this.put<Guid, BrandUpdateRequest>(obj, this.controller);
    }

    getFormEdit(id: Guid): Observable<BrandUpdateRequest> {
        return this.get<BrandUpdateRequest>(this.controller + `/form/${id}`);
    }

    list(obj: SearchRequest): Observable<ListResponse<BrandListResponse[]>> {
        return this.post<ListResponse<BrandListResponse[]>, SearchRequest>(obj, this.controller + `/list`);
    }

    deleteBrand(id: Guid): Observable<boolean> {
        return this.delete<boolean>(`${this.controller}/${id}`);
    }
}
